export default {
  name: 'pageTabs',
  state: {
      keepAliveList:[],
  },
  mutations: {
    setKeepAliveList (state, list) {
      state.keepAliveList = list
    }
  }
}
